module.exports = __webpack_public_path__ + "static/media/18.02c01bc5.png";